//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    background-color: var(--light-blue-2);
    margin: 0 30px;
    padding: 35px 20px;
    padding-left: 30px;
    border-radius: 8px;
`;
export const Content = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100vw;
    margin: 0;
    padding: 0;
    min-width: 200px;
    max-width: 500px;
    max-height: ${({ maxHeight = "190px" }) => maxHeight};
    overflow-y: scroll;
    &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: var(--light-gray-4);
    }
    &::-webkit-scrollbar-track {
        background-color: var(--light-1);
    }
    @media (max-width: 775px) {
        min-width: 100px;
        max-width: 300px;
    }
`;
export const AboutSchedule = styled.li`
    display: flex;
    gap: 15px;
    margin: 0;
    & span {
        font-size: 14px;
        color: var(--light-gray-5);
    }
`;